import Tools from '../views/dashboard/components/tools'
import siteweb from '../views/dashboard/components/siteweb'
import result from '../views/dashboard/components/result'
import question from '../views/dashboard/components/question'
import demande from '../views/dashboard/components/demande'
import devis from '../views/dashboard/components/devis'
import message from '../views/dashboard/components/message'
   import draggable from "vuedraggable"
export const components = {
     Tools: Tools, 
     siteweb: siteweb,
     result: result,
     question: question,
     demande: demande,
     devis: devis,
     message: message,
      draggable: draggable, 
}